import { render, staticRenderFns } from "./button-saving.vue?vue&type=template&id=1d185c25"
import script from "./button-saving.vue?vue&type=script&lang=js"
export * from "./button-saving.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports